import { useState } from "react";
import { Button, Card, Modal } from "@mui/material";
import styled from "styled-components/macro";
import { cardBorder, metricsExplainerBlue } from "../../../constants/colors";
import {
  BREAKPOINT_TABLET,
  FONT_SIZE_SMALL,
} from "../../../constants/constants";
import MetricExplainerContent from "./MetricExplainerContent";
import { MetricExplainerInputType } from "./metricExplainerTypes";

const MetricsExplainerStyles = styled.div`
  .openButton {
    text-transform: none;
    color: ${metricsExplainerBlue};
    font-size: ${FONT_SIZE_SMALL}px;
    border: 1px solid ${metricsExplainerBlue};
    line-height: 20px;
    border-radius: 5px;
    padding: 6px 12px;

    @media print {
      display: none;
    }
  }

  @media (max-width: ${BREAKPOINT_TABLET}px) {
    .openButton {
      font-size: ${FONT_SIZE_SMALL - 2}px;
      line-height: ${FONT_SIZE_SMALL - 2}px;
    }
  }
`;

const MODAL_WIDTH = 1000;
const MODAL_HEIGHT = 480;

const MODAL_WIDTH_MOBILE = 90;
const MODAL_HEIGHT_MOBILE = 80;

const MetricExplainerModal = styled(Card)`
  position: relative;
  margin: auto;

  width: ${MODAL_WIDTH}px;
  height: ${MODAL_HEIGHT}px;
  transform: translateY(50%);

  overflow-y: scroll !important;
  box-shadow: 0px 0px 75px rgba(0, 0, 0, 0.1);
  border: 1px solid ${cardBorder};
  border-radius: 10px;

  @media (max-width: ${BREAKPOINT_TABLET}px) {
    width: ${MODAL_WIDTH_MOBILE}vw;
    height: ${MODAL_HEIGHT_MOBILE}vh;
    transform: translateY(10%);
  }
`;

export default function MetricsExplainer({
  metricsExplainer,
}: {
  metricsExplainer: MetricExplainerInputType[];
}) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <MetricsExplainerStyles>
      <Button type="button" onClick={handleOpen} className="openButton">
        Metrics Explainer
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <MetricExplainerModal elevation={2}>
          <MetricExplainerContent metricsExplainer={metricsExplainer} />
        </MetricExplainerModal>
      </Modal>
    </MetricsExplainerStyles>
  );
}
